// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2ZG2Q","options":"AnswerScale_options__3nlXK","selected":"AnswerScale_selected__1CDSZ"};